<template>
  <div name="demo-export-excel">
  	export excel
  </div>
</template>

<script>
export default {
  name: 'demo-export-excel'
}
</script>


// WEBPACK FOOTER //
// demoExportExcel.vue?1b79e166